import { render, staticRenderFns } from "./Adjust.vue?vue&type=template&id=a511b34c&scoped=true&"
import script from "./Adjust.vue?vue&type=script&lang=js&"
export * from "./Adjust.vue?vue&type=script&lang=js&"
import style0 from "./Adjust.vue?vue&type=style&index=0&id=a511b34c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a511b34c",
  null
  
)

export default component.exports